import SettingsIcon from "@mui/icons-material/Settings";
import { ListItemButton, ListItemIcon, Stack } from "@mui/material";
import { useState } from "react";

import SystemSettingDrawer from "./SystemSettingDrawer";

function SystemSettings() {
  const [panelVisible, setPanelVisible] = useState(false);
  const handleClick = (event: any) => {
    setPanelVisible(true);
  };

  return (
    <>
      <Stack onClick={handleClick} direction={"row"} alignItems={"center"}>
        <ListItemButton>
          <ListItemIcon sx={{ minWidth: "10px"}}>
            <SettingsIcon></SettingsIcon>
          </ListItemIcon>
        </ListItemButton>
      </Stack>
      <SystemSettingDrawer
        visible={panelVisible}
        cancel={() => {
          setPanelVisible(false);
        }}
      ></SystemSettingDrawer>
    </>
  );
}

export default SystemSettings;
